import { render, staticRenderFns } from "./CommonEmpty.vue?vue&type=template&id=090a7b9a&scoped=true"
import script from "./CommonEmpty.vue?vue&type=script&lang=ts"
export * from "./CommonEmpty.vue?vue&type=script&lang=ts"
import style0 from "./CommonEmpty.vue?vue&type=style&index=0&id=090a7b9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a7b9a",
  null
  
)

export default component.exports